import React from 'react';
import Link from 'next/link';
import { routes } from 'env/routes';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';
import { useBWTokenContext } from 'env/context/bwTokenContext';

import CheckinWidgetSmall from 'ui/_pages/home/components/CheckinWidget/CheckinWidgetSmall';
import InvoicesWidgetSmall from 'ui/_pages/home/components/InvoicesWidget/InvoicesWidgetSmall';
import EventsWidgetSmall from 'ui/_pages/home/components/EventsWidget/EventsWidgetSmall';
import DeliveriesWidgetSmall from 'ui/_pages/home/components/DeliveriesWidget/DeliveriesWidgetSmall';
import EnhancedUserWidget from './components/EnhancedUserWidget/EnhancedUserWidget';

import UpcomingBookingsWidget from 'ui/bw-ui/booking/UpcomingBookingsWidget';
import UpcomingEventsWidget from 'ui/bw-ui/events/UpcomingEventsWidget';
import FeaturedBlogPostSection from 'ui/bw-ui/blog/FeaturedBlogPostSection';
import BenefitsAndVisitorsWidget from 'ui/bw-ui/dashboard/BenefitsAndVisitorsWidget';

import CommunityBoardWidget from 'ui/_pages/home/components/CommunityBoardWidget/CommunityBoardWidget';
import VisitorsWidget from 'ui/_pages/home/components/VisitorsWidget/VisitorsWidget';
import BenefitsWidget from 'ui/_pages/home/components/BenefitsWidget/BenefitsWidget';
import DiscountsWidget from 'ui/_pages/home/components/DiscountsWidget/DiscountsWidget';

export const HomeDashboard = withCustomComponent('HomeDashboard')(
  inject(
    'appStore',
    'authStore',
    'homeStore',
  )(
    withRouter(
      observer(({ componentName, appStore, authStore, homeStore }) => {
        const { t } = useTranslation();
        const { configuration, corporateDashboard } = appStore;
        const homeConfig = homeStore.configuration;
        const { business, hasLoadedBusiness } = homeStore;
        const { customer } = authStore;
        const { isEnhancedUser } = useBWTokenContext();
        const fallbackImageUrl =
          'https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoiYnJ1bnR3b29kXC9maWxlXC9rRENidVNVUU5ReU1QTUp1YlZUeC5qcGcifQ:bruntwood:zZ2_2z0zg8BbhacvNbi-1TjX_KzPNhF5Zshhkq2gG6E';
        const heroImageUrl = business?.NativeHomeUrl
          ? business?.NativeHomeUrl + '/images/home-location.jpg'
          : fallbackImageUrl;

        return (
          <>
            <div data-component-name={componentName}>
              {/*  DASHBOARD BODY */}
              <div className="dashboard-body">
                <div className="dashboard-hero-wrapper">
                  <div
                    className="dashboard-hero"
                    style={{
                      backgroundImage:
                        hasLoadedBusiness && `url("${heroImageUrl}")`,
                    }}
                  >
                    <div className="hero-overlay">
                      <div className="container">
                        <div className="row align-items-center">
                          <div className="col-lg-6">
                            <h2 className="mb-4 text-white">
                              {t('Hello')} {customer.GuessedFirstName},
                            </h2>
                            <div className="text-white d-flex">
                              <p>
                                {t('This is what we have for you today at ')}
                                <Link
                                  href={routes.faq}
                                  style={{ textDecoration: 'underline' }}
                                >
                                  {customer.HomeSpaceName}.
                                </Link>
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 text-lg-right pt-20 pt-lg-0">
                            <Link href={routes.my_bookings} className="btn">
                              {t('Manage bookings')}
                            </Link>
                          </div>
                          {configuration['HomePage.ShowCheckedInMembers'] && (
                            <div className="col-md-6 col-xl-3 mt-12">
                              {<CheckinWidgetSmall />}
                            </div>
                          )}
                          {configuration['PublicWebSite.Deliveries'] && (
                            <DeliveriesWidgetSmall />
                          )}
                          {!corporateDashboard &&
                            configuration['Members.ViewInvoices'] && (
                              <div className="col-md-6 col-xl-3 mt-12">
                                {<InvoicesWidgetSmall />}
                              </div>
                            )}
                          {!corporateDashboard &&
                            configuration['PublicWebSite.Events'] && (
                              <div className="col-md-6 col-xl-3 mt-12">
                                {<EventsWidgetSmall />}
                              </div>
                            )}

                          {isEnhancedUser && (
                            <div
                              className="col-md-6 col-xl-3 mt-12"
                              id="home-enhancedUser-widget"
                            >
                              <EnhancedUserWidget />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <UpcomingBookingsWidget />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <UpcomingEventsWidget />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <FeaturedBlogPostSection />
                    </div>
                  </div>

                  <BenefitsAndVisitorsWidget />
                </div>
              </div>
            </div>
          </>
        );
      }),
    ),
  ),
);
